import React, { useState, useRef } from 'react';

const Container = ({ children }) => (
  <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
    {children}
  </div>
);

const Footer = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });
  const footerRef = useRef(null);
  const currentYear = new Date().getFullYear();

  const handleMouseMove = (e) => {
    if (footerRef.current) {
      const rect = footerRef.current.getBoundingClientRect();
      setMousePosition({
        x: ((e.clientX - rect.left) / rect.width - 0.5) * 30,
        y: ((e.clientY - rect.top) / rect.height - 0.5) * 30,
      });
    }
  };

  const footerLinks = {
    servicos: [
      { name: 'Sistemas Web', href: '#' },
      { name: 'Landing Pages', href: '#' },
      { name: 'Aplicativos', href: '#' },
      { name: 'Automação com IA', href: '#' },
      { name: 'UX/UI Design', href: '#' },
    ],
    empresa: [
      { name: 'Sobre nós', href: '#' },
      { name: 'Portfólio', href: '#' },
      { name: 'Blog', href: '#' },
      { name: 'Carreiras', href: '#' },
    ],
    contato: [
      { name: 'maralabssoftware@gmail.com', href: 'mailto:maralabssoftware@gmail.com', external: false },
      { name: 'São Luís, MA', href: '#', external: false },
      { name: 'WhatsApp', href: 'https://wa.me/5598981420180', external: true },
    ],
  };

  const socialLinks = [
    {
      name: 'LinkedIn',
      href: 'https://www.linkedin.com/company/mara-labssoftware',
      icon: 'M19 0h-14c-2.761 0-5 2.239-5 5v14c0 2.761 2.239 5 5 5h14c2.762 0 5-2.239 5-5v-14c0-2.761-2.238-5-5-5zm-11 19h-3v-11h3v11zm-1.5-12.268c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zm13.5 12.268h-3v-5.604c0-3.368-4-3.113-4 0v5.604h-3v-11h3v1.765c1.396-2.586 7-2.777 7 2.476v6.759z'
    },
    {
      name: 'Instagram',
      href: 'https://www.instagram.com/maralabs_',
      icon: 'M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z'
    },
  ];

  return (
    <footer 
      ref={footerRef}
      onMouseMove={handleMouseMove}
      className="relative bg-gradient-to-b from-gray-950 to-black border-t border-gray-900 overflow-hidden"
    >
      {/* Background animado */}
      <div className="absolute inset-0">
        <div 
          className="absolute inset-0 opacity-5 transition-transform duration-500"
          style={{
            transform: `translate(${mousePosition.x * 0.3}px, ${mousePosition.y * 0.3}px)`,
            backgroundImage: 'linear-gradient(rgba(16, 185, 129, 0.3) 1px, transparent 1px), linear-gradient(90deg, rgba(16, 185, 129, 0.3) 1px, transparent 1px)',
            backgroundSize: '60px 60px',
          }}
        />

        <div 
          className="absolute top-1/4 left-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl transition-transform duration-700"
          style={{
            transform: `translate(${mousePosition.x * 2}px, ${mousePosition.y * 2}px)`,
          }}
        />
        <div 
          className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-emerald-500/5 rounded-full blur-3xl transition-transform duration-700"
          style={{
            transform: `translate(${-mousePosition.x * 2}px, ${-mousePosition.y * 2}px)`,
          }}
        />
      </div>

      <Container>
        <div className="relative z-10 py-12 md:py-16">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8 md:gap-12">
            {/* Brand */}
            <div className="lg:col-span-1">
              <div className="mb-6 group">
                <h3 className="text-3xl font-bold mb-3 transition-all duration-500 group-hover:text-emerald-500">
                  <span className="text-white">Mara</span>
                  <span className="text-emerald-500">Labs</span>
                </h3>
                <p className="text-gray-400 text-sm leading-relaxed">
                  Transformamos ideias em software e software em resultado. 
                  Automação potencializada por IA.
                </p>
              </div>

              <div className="flex space-x-4">
                {socialLinks.map((social, index) => (
                  <a
                    key={index}
                    href={social.href}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="group relative w-10 h-10 flex items-center justify-center rounded-full bg-gray-800/50 border border-gray-700 hover:border-emerald-500 transition-all duration-300 hover:scale-110"
                  >
                    <div className="absolute inset-0 rounded-full bg-emerald-500/20 blur-md opacity-0 group-hover:opacity-100 transition-opacity duration-500" />
                    <svg 
                      className="w-5 h-5 text-gray-400 group-hover:text-emerald-500 transition-colors duration-300 relative z-10"
                      fill="currentColor" 
                      viewBox="0 0 24 24"
                    >
                      <path d={social.icon} />
                    </svg>
                  </a>
                ))}
              </div>
            </div>

            {/* Services */}
            <div>
              <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Serviços</h4>
              <ul className="space-y-3">
                {footerLinks.servicos.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href}
                      className="text-gray-400 text-sm hover:text-emerald-500 transition-all duration-300 hover:translate-x-2 inline-block group"
                    >
                      <span className="relative">
                        {link.name}
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-emerald-500 group-hover:w-full transition-all duration-300" />
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Company */}
            <div>
              <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Empresa</h4>
              <ul className="space-y-3">
                {footerLinks.empresa.map((link, index) => (
                  <li key={index}>
                    <a 
                      href={link.href}
                      className="text-gray-400 text-sm hover:text-emerald-500 transition-all duration-300 hover:translate-x-2 inline-block group"
                    >
                      <span className="relative">
                        {link.name}
                        <span className="absolute bottom-0 left-0 w-0 h-0.5 bg-emerald-500 group-hover:w-full transition-all duration-300" />
                      </span>
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div>
              <h4 className="text-white font-bold mb-4 text-sm uppercase tracking-wider">Contato</h4>
              <ul className="space-y-3">
                {footerLinks.contato.map((link, index) => (
                  <li key={index}>
                    {link.external ? (
                      <a 
                        href={link.href}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="text-gray-400 text-sm hover:text-emerald-500 transition-all duration-300 flex items-start group"
                      >
                        <span className="mr-2 mt-0.5 text-emerald-500">→</span>
                        <span className="group-hover:translate-x-1 transition-transform duration-300">
                          {link.name}
                        </span>
                      </a>
                    ) : (
                      <a 
                        href={link.href}
                        className="text-gray-400 text-sm hover:text-emerald-500 transition-all duration-300 flex items-start group"
                      >
                        <span className="mr-2 mt-0.5 text-emerald-500">→</span>
                        <span className="group-hover:translate-x-1 transition-transform duration-300">
                          {link.name}
                        </span>
                      </a>
                    )}
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="relative z-10 border-t border-gray-900 py-6">
          <div className="flex flex-col md:flex-row justify-between items-center space-y-4 md:space-y-0">
            <p className="text-gray-500 text-sm">
              © {currentYear} Mara Labs. Todos os direitos reservados.
            </p>
            
            <div className="flex space-x-6 text-sm">
              <a href="#" className="text-gray-500 hover:text-emerald-500 transition-colors duration-300">
                Privacidade
              </a>
              <a href="#" className="text-gray-500 hover:text-emerald-500 transition-colors duration-300">
                Termos de Uso
              </a>
            </div>
          </div>
        </div>
      </Container>

      <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-emerald-500 to-transparent opacity-50" />
    </footer>
  );
};

export default Footer;